// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-historico-profesional {
  position: relative;
}
.content-historico-profesional .title {
  display: flex;
  align-items: center;
  margin: 25px;
  justify-content: flex-start;
}
.content-historico-profesional .title .icon {
  background: linear-gradient(45deg, #40c2ff 0%, #32d8d8 100%);
  width: 50px;
  height: 50px;
  border-radius: 50rem;
  padding: 8px;
  margin: 0 10px;
}
.content-historico-profesional .title .icon svg {
  fill: white;
  width: 100%;
}

.professional-historic-subtitle {
  color: #000;
}

.professional-historic-title {
  font-size: 1em;
  color: #000;
}
.professional-historic-title small {
  font-size: 0.8em;
  color: #303030;
  font-weight: 500;
}

.professional-historic-slot {
  width: 30px;
  height: 12px;
  border: 1px solid #7a6be6;
  border-radius: 4px;
  margin-right: 3px;
}

.professional-historic-slot-fill {
  background-color: #7a6be6;
}

.professional-historic-badge {
  font-size: 10px;
  border: 1px solid #303030;
  border-radius: 50px;
  color: #303030;
  margin-right: 5px;
  margin-bottom: 5px;
  padding: 5px 15px;
  float: left;
}

.h-employee {
  margin: 0;
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.2rem;
  color: #303030;
}

.h-card {
  display: flex;
  gap: 1rem;
  margin: 3rem;
  color: #303030;
}
.h-card-header {
  align-items: center;
}
.h-card-content {
  width: 100%;
  padding: 10px;
}
.h-card__title {
  font-size: 1.4rem;
  line-height: 2rem;
}
.h-card__description {
  font-size: 0.8rem;
}`, "",{"version":3,"sources":["webpack://./src/Views/Analytics/historicoProfesional.sass"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AACI;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,2BAAA;AACR;AACQ;EACI,4DAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;EACA,cAAA;AACZ;AACY;EACI,WAAA;EACA,WAAA;AAChB;;AACA;EACI,WAAA;AAEJ;;AAAA;EACI,cAAA;EACA,WAAA;AAGJ;AADI;EACI,gBAAA;EACA,cAAA;EACA,gBAAA;AAGR;;AADA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AAIJ;;AAFA;EACI,yBAAA;AAKJ;;AAHA;EACI,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;AAMJ;;AAJA;EACI,SAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AAOJ;;AAJA;EACI,aAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;AAOJ;AANI;EACI,mBAAA;AAQR;AAPI;EACI,WAAA;EACA,aAAA;AASR;AAPI;EACI,iBAAA;EACA,iBAAA;AASR;AARI;EACI,iBAAA;AAUR","sourcesContent":[".content-historico-profesional\n    position: relative\n\n    & .title\n        display: flex\n        align-items: center\n        margin: 25px\n        justify-content: flex-start\n\n        & .icon\n            background: linear-gradient(45deg,#40c2ff 0%, #32d8d8 100%)\n            width: 50px\n            height: 50px\n            border-radius: 50rem\n            padding: 8px\n            margin: 0 10px\n\n            & svg\n                fill: white\n                width: 100%\n\n.professional-historic-subtitle\n    color: #000\n\n.professional-historic-title\n    font-size: 1.0em\n    color: #000\n\n    & small\n        font-size: 0.8em\n        color: #303030\n        font-weight: 500\n\n.professional-historic-slot\n    width: 30px\n    height: 12px\n    border: 1px solid #7a6be6\n    border-radius: 4px\n    margin-right: 3px\n\n.professional-historic-slot-fill\n    background-color: #7a6be6\n\n.professional-historic-badge\n    font-size: 10px\n    border: 1px solid #303030\n    border-radius: 50px\n    color: #303030\n    margin-right: 5px\n    margin-bottom: 5px\n    padding: 5px 15px\n    float: left\n\n.h-employee\n    margin: 0\n    font-weight: 600\n    font-size: 1rem\n    line-height: 1.2rem\n    color: #303030\n\n\n.h-card\n    display: flex\n    gap: 1rem\n    margin: 3rem\n    color: #303030\n    &-header\n        align-items: center\n    &-content\n        width: 100%\n        padding: 10px\n\n    &__title\n        font-size: 1.4rem\n        line-height: 2rem\n    &__description\n        font-size: 0.8rem\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
